module.exports = __webpack_public_path__ + "img/HongYaC.ba0b3c1a.svg";